import cx from "classnames";

import s from "./ProgressBar.module.scss";
import { IonLabel } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { useBreakpoint } from "../../../Common/utils/common";

export const ProgressBar = ({ isOneOffEntry }: { isOneOffEntry?: boolean }) => {
  const [current, setCurrent] = useState(0);
  const startTime = useRef<number | null>(null);
  const breakpoint = useBreakpoint();
  useEffect(() => {
    const progress = breakpoint !== "laptop" ? 80 : 90; // max percentage
    const duration = 700; // max ms

    const animate = (timestamp: number) => {
      if (!startTime.current) startTime.current = timestamp;
      const elapsed = timestamp - startTime.current;
      const newProgress = Math.min((elapsed / duration) * progress, progress);
      setCurrent(newProgress);
      if (elapsed < duration) {
        requestAnimationFrame(animate);
      }
    };
    requestAnimationFrame(animate);
  }, [breakpoint]);

  return (
    <div
      className={cx(s.progressTipContainer, {
        [s.mobile]: breakpoint !== "laptop",
      })}
    >
      <div className={s.cardProgress}>
        <>
          <IonLabel className={cx(s.text, "win-header-6 medium gilroy dark")}>
            Download app to complete set up!
          </IonLabel>
          <div className={s.meter}>
            <span style={{ width: `${current}%` }}></span>
            {!isOneOffEntry && (
              <div className={s.tooltipWrapper}>
                <div className={s.box}>
                  <IonLabel
                    className={cx(s.text, "win-sub medium gilroy white")}
                  >
                    Free Entries
                  </IonLabel>
                  <div className={s.arrow} />
                </div>
              </div>
            )}
          </div>
        </>
      </div>
    </div>
  );
};
